<template>
  <loading
    :active.sync="loading"
    :can-cancel="false"
    :is-full-page="false"
    background-color="#f0f0f0"
    loader="bars"
    v-bind:height="spinnerPanelHeight"
    v-bind:width="spinnerPanelWidth"
  >
    <div class="googleMapSpinnerPanel">
      <Spinner v-if="loading"></Spinner>
    </div>
  </loading>
</template>
<script>
import Spinner from '@wizer/core/components/spinner/Spinner'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  /**
   * Name of the component
   */
  name: 'GoogleMapSpinner',
  /**
   * Components used
   */
  components: { Loading, Spinner },
  /**
   * This components properties
   */
  props: ['mapSize'],
  /**
   * This component's data attributes
   */
  data() {
    return {
      loadingActive: [],
    }
  },
  /**
   * Computed properties
   */
  computed: {
    loading() {
      const self = this
      this.$nextTick(() => {
        if (this.loadingActive.length === 0) {
          self.$emit('loading', false)
        }
      })
      return this.loadingActive.length > 0
    },
    spinnerPanelWidth() {
      return parseInt(this.mapSize.width, 10)
    },
    spinnerPanelHeight() {
      return parseInt(this.mapSize.height, 10) + 10
    },
  },
  /**
   * Component methods
   */
  methods: {
    loadingStart() {
      const self = this
      this.$nextTick(() => {
        self.loadingActive.push(1)
        self.$emit('loading', true)
      })
    },
    loadingStop() {
      const self = this
      this.$nextTick(() => {
        self.loadingActive.pop()
      })
    },
  },
}
</script>
<style lang="postcss">
.googleMapSpinnerPanel {
  @apply absolute z-20;
  left: 50%;
  top: 50%;
}
</style>
